import axios from 'axios';

import type { DefaultApiResponse } from '../_types';
import { parseFeaturesForUI } from './features.parsers';
import type { Features, FeaturesDto } from './features.types';

const endpoint = 'features/';

type GetFeaturesQuery = () => Promise<Features>;

const featuresApi = {
  get: (): GetFeaturesQuery => async () => {
    const response = await axios.get<GetFeaturesQuery, DefaultApiResponse<FeaturesDto>>(endpoint);
    return parseFeaturesForUI(response.data);
  },
};

export default featuresApi;
